import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { Location } from '@angular/common';

export const LOCAL_STORAGE_URL_BEFORE_REDIRECT = 'url_before_redirect';
export const isAuthenticatedCanActivateFn: CanActivateFn = (route) => {
    const authenticationService = inject(AuthenticationService);
    const router = inject(Router);
    const location = inject(Location);

    if (authenticationService.isLoggedIn()) {
        return true;
    } else {
        localStorage.setItem(LOCAL_STORAGE_URL_BEFORE_REDIRECT, location.path(true));
        return router.parseUrl('/auth/login');
    }
};
